import { Injectable } from '@angular/core';
import { CartDto } from '../generate-client';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    constructor() { }

    getToken() {
        return localStorage.getItem('token');
    }

    setToken(value: any) {
        this.setItem('token', value);
    }

    getCartNo() {
        return localStorage.getItem('cart_no');
    }
    setCartNo(value: any) {
        this.setItem('cart_no', value);
    }
    clearCartNo() {
        localStorage.removeItem('cart_no');
    }

    getLid() {
        return localStorage.getItem('lid');
    }

    setLid(value: any) {
        this.setItem('lid', value);
    }

    getUserId() {
        return localStorage.getItem('user_id');
    }
    setUserId(value) {
        this.setItem('user_id', value);
    }

    getCartData() {
        return JSON.parse(localStorage.getItem('cart_data'));
    }
    setCartData(value: CartDto) {        
        this.setItem('cart_data', JSON.stringify(value));
    }
    clearCartData() {
        localStorage.removeItem('cart_data');
    }


    getRestaurantData() {        
        return JSON.parse(localStorage.getItem('restaurant_data'));
    }
    setRestaurantData(value: any) {
        this.setItem('restaurant_data', JSON.stringify(value));
    }
    clearRestaurantData() {        
        localStorage.removeItem('restaurant_data');
    }

    private removeItem(key: string) {
        localStorage.removeItem(key);
    }

    setItem(key: string, value: any) {
        if (!value || value == 'null') {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, value);
        }
    }

}